import {all} from 'redux-saga/effects';
import {markableAsReadFeatureSaga} from './markable-as-read/sagas';

export function* featuresSaga() {
    yield all([
        markableAsReadFeatureSaga(),
    ]);
}
